// src/pages/History/Modern/BritishEmpireGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/19th_Century_-_British_Empire.png';

function HistoryPageBritishEmpireGo() {
  return (
    <QuizPage
      title="History: British Empire"
      subTopic="British Empire"
      backgroundImage={historyImage}
      returnPath="/History-British-Empire"
    />
  );
}

export default HistoryPageBritishEmpireGo;
